import RadioGroup from './src/RadioGroup';

export default RadioGroup;
